var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Driver-on-the-way(Share-ETA)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Track-Driver---Go-full-receipt",
    transform: "translate(-1254.000000, -772.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1254.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 3.91959799
  }), /*#__PURE__*/React.createElement("g", {
    id: "apple-copy-2",
    transform: "translate(16.000000, 6.000000)",
    fill: "#0E730F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.34176301,11.4797291 C-1.34794083,16.0080887 0.361953504,22.8801235 3.33632679,27.0468823 C4.82100993,29.1300592 6.32415642,31 8.38297684,31 C8.42178118,31 8.46068983,30.9992916 8.50053729,30.9977735 C9.46782927,30.9603281 10.1668289,30.6713916 10.8426711,30.3921706 C11.6014419,30.0784391 12.3861866,29.7540812 13.6170769,29.7540812 C14.7880916,29.7540812 15.535388,30.0679139 16.2580667,30.3713226 C16.970314,30.6702783 17.7039455,30.9795569 18.7879634,30.9598221 C21.1070441,30.9179238 22.5309129,28.9001244 23.7871512,27.1200525 C25.0980493,25.2614466 25.7556367,23.4568834 25.9775099,22.7672814 L25.9864808,22.7398552 C26.0287275,22.6172975 25.9690606,22.4835062 25.8479535,22.4295647 C25.8446155,22.4280466 25.8323066,22.4230876 25.8288643,22.4216708 C25.4204799,22.2596437 21.838172,20.7178053 21.8005151,16.5154228 C21.7655704,13.1012148 24.4879241,11.2932107 25.0338969,10.9655131 L25.0593493,10.9501302 C25.1184946,10.9131908 25.1596981,10.8545939 25.173676,10.787597 C25.1876539,10.7207014 25.1730501,10.6510732 25.1334113,10.594804 C23.2543217,7.92687204 20.3742471,7.52478974 19.2147068,7.47641437 C19.0464503,7.46012058 18.8727696,7.45192308 18.6983588,7.45192308 C17.3364517,7.45192308 16.0318123,7.95095852 14.983678,8.35192758 C14.2601649,8.6287197 13.6352273,8.86776284 13.2042071,8.86776284 C12.7198831,8.86776284 12.0913988,8.62578479 11.3636089,8.34565295 C10.3903711,7.97089565 9.28726393,7.54624493 8.11948288,7.54624493 C8.09163138,7.54624493 8.06419713,7.54654854 8.03718013,7.54705455 C5.32191967,7.58581557 2.75624368,9.09294107 1.34176301,11.4797291 Z",
    id: "XMLID_229_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.57137,0.000200543225 C17.8859862,0.0672071054 15.8642314,1.07992466 14.6558188,2.4615958 C13.6288499,3.62293851 12.6256172,5.55924028 12.8899241,7.51098905 C12.9064967,7.63310382 13.0082848,7.72735136 13.1341299,7.73684918 C13.247893,7.74551202 13.3640084,7.74989563 13.4796961,7.75 C15.1276578,7.75 16.9054207,6.86002343 18.1195001,5.42700147 C19.3973039,3.91382213 20.0434229,1.97188429 19.8479727,0.232427336 C19.8325762,0.0961180364 19.7097248,-0.00512240797 19.57137,0.000200543225 Z",
    id: "XMLID_230_"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Download-on-the-Copy-2",
    fontFamily: "Roboto-Light, Roboto",
    fontSize: 4.52261307,
    fontWeight: 300,
    fill: "#0E730F"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 44
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "App-Store-Copy-2",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 10.5527638,
    fontWeight: "normal",
    fill: "#0E730F"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 54
  }, "App Store")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple_store.954993324360d9aba2c96fdfdf9114da.svg";
export { ForwardRef as ReactComponent };